import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BuildingHistoryDialogComponent } from '@app/energy-map/dialog/building-history-dialog/building-history-dialog.component';
import { EnergyMarker } from '@app/shared/models/energiekarte/epmarker';
import { GetAddressPipe } from '@app/shared/pipes/get-address.pipe';
import { AuthService } from '@app/shared/services/auth.service';

@Component({
  selector: 'app-building-details',
  templateUrl: './building-details.component.html',
  styleUrls: ['./building-details.component.scss'],
  providers: [GetAddressPipe],
})
export class BuildingDetailsComponent {
  showDelay = new FormControl(1000);
  hideDelay = new FormControl(2000);

  @Input() data: EnergyMarker = {} as EnergyMarker;
  @Output() editMode = new EventEmitter();

  constructor(public authService: AuthService, private matDialog: MatDialog) {}

  editBuilding() {
    this.editMode.emit(true);
  }

  openHistoryDialog() {
    this.matDialog.open(BuildingHistoryDialogComponent, {
      data: {
        buildingId: this.data.guid,
      },
      position: { top: '140px', left: '500px' },
      panelClass: ['-sm'],
    });
  }
}
